module.exports = __webpack_public_path__ + "static/media/history-2.05c0875d.jpg";